/*
 * Authors: mariushirjanu
 * Created: 22/08/2022
 */
import { util } from '../../shared/util';
import * as _ from 'underscore';
import { IGlobalItem, IProductImagesHolder, IProperty, IPropertyGroup } from './global-product-data.service';
import { Injectable } from '@angular/core';
import { IProductImage } from '../../../type_definitions/datatypes';

@Injectable()
export class GlobalProductService {
  private _images:IProductImagesHolder;
  private _displayImages:string[];
  private _imagesLoaded:boolean;
  private _product:IGlobalItem;
  private _properties:IPropertyGroup[];
  private _originalProduct:IGlobalItem;

  constructor() {
    /***/
  }

  public product(product?:IGlobalItem):IGlobalItem {
    if (arguments.length) {
      this._product = this.prepareProduct(product);
      this._originalProduct = util.deepClone(this._product);
    }
    return this._product;
  }

  public clearData():void {
    this._product = undefined;
    this._images = undefined;
    this._displayImages = undefined;
    this._properties = undefined;
    this._imagesLoaded = undefined;
  }

  public reset():void {
    this.product(this._originalProduct);
  }

  public images(images?:IProductImagesHolder):IProductImagesHolder {
    if (arguments.length) {
      this._images = images;
      this._displayImages = this.prepareDisplayImages(this._images.images || this._images.modelImages);
      this._imagesLoaded = true;
    }
    return this._images;
  }

  public displayImages():string[] {
    return this._displayImages;
  }

  public get imagesLoaded():boolean {
    return this._imagesLoaded;
  }

  public properties(properties?:IPropertyGroup[]):IPropertyGroup[] {
    if (arguments.length) {
      this._properties = this.prepareProps(properties);
    }
    return this._properties;
  }

  public prepareDisplayImages(images:IProductImage[]):string[] {
    return _.pluck(images, 'url');
  }

  private prepareProduct(product:IGlobalItem) {
    if (product?.properties) {
      product.properties = _.map(product.properties, (propList:any) => {
        propList.values = _.map(propList.values, (prop:any) => {
          if (prop.unit) {
            prop.unit.id = prop.unit.value;
          }
          return prop;
        });
        return propList;
      });
    }

    return product;
  }

  private prepareProps(props:IPropertyGroup[]):IPropertyGroup[] {
    return _.map(props, (propList:IPropertyGroup) => {
      propList.values = _.map(propList.values, (prop:IProperty) => {
        if (prop.units?.length > 1) {
          prop.units = _.map(prop.units, (unit:any) => {
            unit.id = unit.value;
            return unit;
          });
        }
        return prop;
      });
      return propList;
    });
  }
}